module.exports = __webpack_public_path__ + "videos/19.8139811.mp4";